// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pricep-form {\n  text-align: center;\n}\npricep-form table {\n  display: inline-block;\n}", ""]);
// Exports
module.exports = exports;
